export default "__VITE_ASSET__DbrdGxWT__"